import metaMask from "assets/icons/connectors/metamask.png";
import coinbaseWallet from "assets/icons/connectors/coinbaseWallet.png";
import walletConnect from "assets/icons/connectors/walletConnect.png";
import disconnect from "assets/icons/connectors/disconnect.png";

export const connectorIcons = {
  metaMask,
  coinbaseWallet,
  walletConnect,
  disconnect,
};
